// Tracks the most recently *recorded* pathname so a list page can tell, on
// mount, whether the user is returning from one of its own detail pages
// (e.g. /dashboard/companies/123 -> /dashboard/companies) versus arriving
// fresh from somewhere else. The Dashboard layout records the path in an
// effect *after* render, so during a child page's first render this value
// still points at the page we navigated away from.
let recordedPath = null;

export function recordPath(pathname) {
  recordedPath = pathname;
}

export function getRecordedPath() {
  return recordedPath;
}
